/******/ (() => { // webpackBootstrap
class CartUpdateModal extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('textarea');
    this.label = this.querySelector('[data-cart-update-label]');
    this.openButton = this.querySelector('[data-cart-update-open]');
    this.openButtonText = this.querySelector('[data-cart-update-open-text]');
    this.closeButtons = this.querySelectorAll('[data-cart-update-close]');
    this.saveButton = this.querySelector('[data-cart-update-save]');
    this.errorMessage = this.querySelector('[data-cart-update-error]');
    this.cartUpdate = this.querySelector('cart-update');
    this.modal = this.querySelector('[data-cart-update-modal]');
    this.overlay = this.querySelector('[data-cart-update-overlay]');
    this.handleOpen = this.handleOpen.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-update-modal'});
    if (!this.input) return;
    this.savedValue = this.input.value;
    this.openButton.addEventListener('click', this.handleOpen);
    this.modal.addEventListener('transitionend', this.handleTransitionEnd);
    this.addEventListener('keyup', this.handleEscape, true);
    this.closeButtons.forEach(button => button.addEventListener('click', this.handleClose));
    this.saveButton.addEventListener('click', this.handleSave);
  }

  handleOpen() {
    /* ===== Open modal ===== */
    this.input.value = this.savedValue;
    this.errorMessage.hidden = true;
    this.setAttribute('open', true);
    this.modal.setAttribute('aria-hidden', false);

    /* ===== Set input label text content - add or edit ===== */
    const labelText = this.savedValue ? this.editLabelText : this.addLabelText;
    this.label.textContent = labelText;
  }

  handleTransitionEnd(e) {
    /* ===== Trap focus once modal is fully open ===== */
    if (e.target === this.modal) {
      this.trapFocus();
    }
  }

  handleClose() {
    if (this.isSaving) return;
    /* ===== Close modal ===== */
    this.input.value = this.savedValue;
    this.removeAttribute('open');
    this.modal.setAttribute('aria-hidden', true);

    /* ===== Set open button text content - add or edit ===== */
    const labelText = this.savedValue ? this.editLabelText : this.addLabelText;
    this.openButtonText.textContent = labelText;
  }

  async handleSave() {
    if (this.isSaving) return;
    const value = this.input.value;
    this.isSaving = true;
    this.saveButton.disabled = true;
    this.input.disabled = true;
    this.modal.setAttribute('aria-busy', 'true');
    this.errorMessage.hidden = true;

    let saved = false;
    try {
      await this.cartUpdate.save(value);
      this.savedValue = value;
      // Keep the full-cart field in sync when its drawer is opened on /cart.
      const cartPageInput = document.querySelector(`#CartPage-Form textarea[name="${this.input.name}"]`);
      if (cartPageInput) cartPageInput.value = this.savedValue;
      saved = true;
    } catch (error) {
      console.error('Failed to save cart note:', error);
      this.errorMessage.hidden = false;
    } finally {
      this.isSaving = false;
      this.saveButton.disabled = false;
      this.input.disabled = false;
      this.modal.removeAttribute('aria-busy');
    }

    if (saved) this.handleClose();
    else this.input.focus();
  }

  trapFocus() {
    const focusableElements = this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  }

  handleEscape(e) {
    /* ===== Close modal when escape key is pressed ===== */
    if (e.key === 'Escape') {
      e.stopPropagation(); // Prevent the drawer from closing
      this.handleClose();
    }
  }

  get addLabelText() {
    return this.getAttribute('data-add-label');
  }

  get editLabelText() {
    return this.getAttribute('data-edit-label');
  }
}

customElements.define('cart-update-modal', CartUpdateModal);
/******/ })()
;
